import countriesA from './countriesA';
import countriesB from './countriesB';
import countriesC from './countriesC';
import countriesD from './countriesD';
const countries = [...countriesA, ...countriesB, ...countriesC, ...countriesD];
export default countries;
